import { createFileRoute, redirect } from "@tanstack/react-router";

// The privacy policy is a Builder page served at /page/privacy-policy.
// People (and crawlers) guess this conventional URL — send them there.
export const Route = createFileRoute("/_public/privacy-policy")({
  beforeLoad: () => {
    throw redirect({
      to: "/page/$name",
      params: { name: "privacy-policy" },
      statusCode: 301,
    });
  },
  component: () => null,
  staticData: { title: "Privacy Policy" },
});
